import { useEffect, useState } from 'react';

interface SnackbarProps {
  message: string;
  show: boolean;
  onHide: () => void;
  duration?: number;
}

export function Snackbar({ message, show, onHide, duration = 3000 }: SnackbarProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!show) return;
    setVisible(true);
    const t = setTimeout(() => {
      setVisible(false);
      setTimeout(onHide, 200); // let fade finish before clearing
    }, duration);
    return () => clearTimeout(t);
  }, [show, duration, onHide]);

  if (!show && !visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed bottom-6 left-1/2 z-50 -translate-x-1/2 rounded-md bg-neutral-900 px-4 py-2.5 text-sm text-white shadow-lg transition-all duration-200 dark:bg-neutral-100 dark:text-neutral-900 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
      }`}
    >
      {message}
    </div>
  );
}
